export const INTERACTION_TYPE_SET = 'INTERACTION_TYPE_SET';
export const ANSWER_DESCRIPTION_SET = 'ANSWER_DESCRIPTION_SET';
export const POLL_TYPE_VALUE_SET = 'POLL_TYPE_VALUE_SET';

export const NETWORK_VALUE_SET = 'NETWORK_VALUE_SET';
export const TOKENS_TO_DELEGATE_SET = 'TOKENS_TO_DELEGATE_SET';
